import { useTakeoverContext } from 'modules/sendingPlatforms/contexts';
import { Button } from 'ui/button';
import { PanelFooter } from 'ui/takeOver';

export const TakeoverFooter = () => {
  const { closeTakeover } = useTakeoverContext();

  return (
    <PanelFooter data-test="takeover-footer">
      <Button onClick={closeTakeover}>Done</Button>
    </PanelFooter>
  );
};
